import * as i0 from "@angular/core";
export class ISGProvider {
    constructor(id, ZipCode, Provider, Technology, MaxSpeed, City, Campaign, Url, Phone) {
        this.id = id;
        this.ZipCode = ZipCode;
        this.Provider = Provider;
        this.Technology = Technology;
        this.MaxSpeed = MaxSpeed;
        this.City = City;
        this.Campaign = Campaign;
        this.Url = Url;
        this.Phone = Phone;
    }
}
// @Injectable({
//   providedIn: "root"
// })
// export class ISGAdapter implements Adapter<ISGProvider> {
//   adapt(item: any): ISGProvider {
//       return new ISGProvider(item.id, item.ZipCode, item.Provider, item.Technolgy, item.MaxSpeed, item.City, item.Campaign, item.Url, item.Phone)
//   }
// }
export class ISGObject {
    constructor(dslCable, fiber, satellite) {
        this.dslCable = dslCable;
        this.fiber = fiber;
        this.satellite = satellite;
    }
}
export class ISGProviderAdapter {
    adapt(item) {
        var dslCable = item.dslCable;
        var fiber = item.fiber;
        var satellite = item.satellite;
        return new ISGObject(new ISGProvider(dslCable.id, dslCable.ZipCode, dslCable.Provider, dslCable.Technolgy, dslCable.MaxSpeed, dslCable.City, dslCable.Campaign, dslCable.Url, dslCable.Phone), new ISGProvider(fiber.id, fiber.ZipCode, fiber.Provider, fiber.Technolgy, fiber.MaxSpeed, fiber.City, fiber.Campaign, fiber.Url, fiber.Phone), new ISGProvider(satellite.id, satellite.ZipCode, satellite.Provider, satellite.Technolgy, satellite.MaxSpeed, satellite.City, satellite.Campaign, satellite.Url, satellite.Phone));
    }
}
ISGProviderAdapter.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ISGProviderAdapter_Factory() { return new ISGProviderAdapter(); }, token: ISGProviderAdapter, providedIn: "root" });
